<template>
	<ValidationProvider ref="provider" :name="options.label" :rules="options.rules" v-slot="{ errors }" slim>
		<div class="checkboxElement" :class="[options.elemClass]" @click="$emit('click', $event)">
			<div :class="[options.wrapperClass, { disabled: disabled }]" ref="parent">
				<input
					type="checkbox"
					:class="options.className"
					:id="generatedId"
					:value="getData()"
					@input="handleCheck"
					:checked="getData()"
					:disabled="disabled"
					data-hj-allow
				/>
				<span class="chbox_style"></span>
				<span>
					<label :for="generatedId" :class="{ disabled: disabled }">
						<span v-html="options.label"></span>
						<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
					</label>
				</span>
			</div>
			<span class="error_message error_message--broke">{{ errors[0] }}</span>
		</div>
	</ValidationProvider>
</template>

<script>
import shared from '@/mixins/shared';
import { mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';

export default {
	mixins: [shared],
	computed: {
		...mapGetters(['getStateData']),
		...mapGetters('contracting', ['getCheckboxData']),
	},
	methods: {
		...mapMutations(['setStateData']),
		...mapMutations('contracting', ['setCheckboxData']),
		handleCheck() {
			if (this.type === 'calculation') {
				this.setStateData({ prop: this.options.prop, value: !this.getStateData(this.options.prop) });

				if (_.has(this.options, 'event')) {
					this.$store.commit(this.options.event);
				}
			}

			if (this.type === 'contracting') {
				this.setCheckboxData({
					group: this.options?.group,
					insurer: this.options?.insurer,
					prop: this.options.prop,
					value: !this.getCheckboxData(this.options.prop, this.options?.group, this.options?.insurer),
				});
			}

			if(this.$refs.parent.classList.contains('checkbox-field-statement')) {
				if(this.getData()) {
					this.$refs.parent.classList.remove('error-field');
				} else {
					this.$refs.parent.classList.add('error-field');
				}
			}
		},
		getData() {
			if (this.type === 'calculation') {
				return this.getStateData(this.options.prop);
			}

			if (this.type === 'contracting') {
				return this.getCheckboxData(this.options.prop, this.options?.group, this.options?.insurer);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.plus-coverage {
	font-size: 14px;
	line-height: 16px;
}

.disabled {
	input {
		cursor: not-allowed;
		pointer-events: none;
	}

	label {
		cursor: not-allowed;
		pointer-events: none;

		span:not(.info) {
			pointer-events: none;
		}
	}

	.chbox_style {
		background-color: #ccc;

		&::before {
			border-bottom: 3px solid #777778 !important;
			border-right: 3px solid #777778 !important;
		}
	}
}
</style>
